import { render } from "./DialogNuovaScadenzaMezzo.vue?vue&type=template&id=3ffacf82&scoped=true"
import script from "./DialogNuovaScadenzaMezzo.vue?vue&type=script&lang=js"
export * from "./DialogNuovaScadenzaMezzo.vue?vue&type=script&lang=js"

import "./DialogNuovaScadenzaMezzo.vue?vue&type=style&index=0&id=3ffacf82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ffacf82"]])

export default __exports__